// @flow
import styled from 'styled-components'
import { Card } from 'antd'
import { Chart } from 'bizcharts'

export const StyledSection = styled.section`
  height: 326px;
  width: 100%;
`

export const StyledChart = styled(Chart)`
  height: 100%;
  width: 100%;
`

export const InnerCard = styled(Card)`
  padding: 0;
  width: 100%;
  & .ant-card-body {
    height: 198px;
    padding-left: 0;
    padding-right: 0;
  }
  & canvas {
    width: 100% !important;
  }
`



// WEBPACK FOOTER //
// ./src/components/chart-stock/style.js